// Vendor Libs
import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {get, forEach, startsWith} from 'lodash';

// Components
import Dropdown from './dropdown';

// Styles
import './dropdown.scss';

class NavDropdown extends Component {
    getProps() {
        const {activeClassName = 'nav-dropdown--active', buttonClassName, className} = this.props;

        return {
            ...this.props,
            buttonClassName: classnames(
                {
                    [activeClassName]: this.isActive(),
                },
                buttonClassName
            ),
            className: classnames('nav-dropdown', className),
        };
    }

    isActive() {
        const {activePaths = [], location} = this.props;
        let match = false;

        forEach(activePaths, (path) => {
            if (startsWith(location, path)) {
                match = true;

                return false;
            }
        });

        return match;
    }

    render() {
        return <Dropdown {...this.getProps()} />;
    }
}

NavDropdown.propTypes = {
    activeClassName: PropTypes.string,
    activePaths: PropTypes.array,
    buttonClassName: PropTypes.string,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    dropdownRenderer: PropTypes.func.isRequired,
    location: PropTypes.string.isRequired,
    type: PropTypes.string,
};

const mapStateToProps = (state) => ({
    location: get(state.router, 'location.pathname', ''),
});

export default connect(mapStateToProps, null)(NavDropdown);
